// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3gYox","header":"PatientBlock_header__19FnB","label":"PatientBlock_label__24SBE","option":"PatientBlock_option__3a_iB"};